const modalWhatapp = document.getElementById('modal__whatapp');

if (modalWhatapp) {
    const callUsElement = modalWhatapp.querySelector('.call-us');
    const whatappLink = modalWhatapp.querySelector('.whatapp--link');

    modalWhatapp.addEventListener('click', function (event) {
        event.stopPropagation();
        if (callUsElement) {
            callUsElement.classList.toggle('active');
        }
    });

    if (whatappLink) {
        whatappLink.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    }

    document.addEventListener('click', function (event) {
        const isClickOutside = !event.composedPath().includes(modalWhatapp);
        if (isClickOutside && callUsElement) {
            callUsElement.classList.add('active');
        }
    });

}